
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5F2lh", function(module, exports) {

$parcel$export(module.exports, "RootEntrypointWrapper", () => $bbc786cfaae469d9$export$40adc4cb138cacb1);

var $5uXOq = parcelRequire("5uXOq");

var $93KvU = parcelRequire("93KvU");
const $bbc786cfaae469d9$export$40adc4cb138cacb1 = ({ props: props, queries: { rootUiModificationsQuery: rootUiModificationsQuery } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93KvU.UiModificationsRoot), {
        ...props,
        queryReference: rootUiModificationsQuery
    });
};

});
parcelRegister("93KvU", function(module, exports) {

$parcel$export(module.exports, "UiModificationsRoot", () => $dbeb12f6a591e7b3$export$da1a4f52b34addd2);

var $2OMIu = parcelRequire("2OMIu");

var $kP1PJ = parcelRequire("kP1PJ");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8Uumt = parcelRequire("8Uumt");

var $kZxLv = parcelRequire("kZxLv");

var $hzwoc = parcelRequire("hzwoc");
const $dbeb12f6a591e7b3$export$da1a4f52b34addd2 = (props)=>{
    const { queryReference: queryReference } = props;
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZxLv.default), {
        name: "ui-modifications-root-query",
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($dbeb12f6a591e7b3$var$RootQuery, {
            ...props,
            queryReference: queryReference
        })
    });
};
const $dbeb12f6a591e7b3$var$RootQuery = (props)=>{
    (0, $gKZoD.di)((0, $hzwoc.UiModificationsRootFragment));
    const { queryReference: queryReference, ...restProps } = props;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $kP1PJ.default), queryReference);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hzwoc.UiModificationsRootFragment), {
        ...restProps,
        fragmentRef: data
    });
};

});
parcelRegister("hzwoc", function(module, exports) {

$parcel$export(module.exports, "UiModificationsRootFragment", () => $e182c60c2e6e9bc5$export$c460318ed1ecaf23);

var $2OMIu = parcelRequire("2OMIu");

var $3WrhE = parcelRequire("3WrhE");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8Uumt = parcelRequire("8Uumt");

var $b9h8P = parcelRequire("b9h8P");

var $juYnC = parcelRequire("juYnC");

var $k2BnG = parcelRequire("k2BnG");

var $lyovk = parcelRequire("lyovk");

var $385kh = parcelRequire("385kh");

var $bBeSA = parcelRequire("bBeSA");

var $kNIwY = parcelRequire("kNIwY");

var $iSXsw = parcelRequire("iSXsw");

var $7XJD9 = parcelRequire("7XJD9");

var $fKN80 = parcelRequire("fKN80");
const $e182c60c2e6e9bc5$export$c460318ed1ecaf23 = (props)=>{
    const executionContext = (0, $fKN80.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $lyovk.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $juYnC.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $bBeSA.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $bBeSA.isExecutionContextSupported)(executionContext);
    (0, $5uXOq.useEffect)(()=>{
        // `executionContextKey` has to be the dependency of the useEffect
        // to set the shouldUiModificationsLoad state according to context changes
        // that is represented by the `executionContextKey`
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e182c60c2e6e9bc5$var$RootFragmentWithCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */ const $e182c60c2e6e9bc5$var$RootFragmentWithCleanup = (props)=>{
    (0, $gKZoD.di)((0, $b9h8P.default));
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $7XJD9.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $5uXOq.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9h8P.default), {
        data: analyticsContextData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k2BnG.ExecutionContextProvider), {
            value: executionContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $385kh.TenantContextProvider), {
                value: tenantContext,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($e182c60c2e6e9bc5$var$RootFragment, {
                    ...props
                })
            })
        })
    });
};
// TODO remove unused props from types and usages
const $e182c60c2e6e9bc5$var$RootFragment = ({ fragmentRef: fragmentRef, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    (0, $gKZoD.di)((0, $kNIwY.AppsRenderer));
    const response = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $3WrhE.default), /* eslint-enable @atlassian/relay/unused-fields */ fragmentRef);
    const appsToRender = (0, $iSXsw.useAppsToRender)({
        data: response,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNIwY.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("3WrhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e39282743a555e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ee8fc33bdb290460d58039c029220c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e39282743a555e2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "forgeExtensionRenderingContext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeEgressOverridesForge"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "uiModificationsContext"
            }
        ],
        "kind": "Fragment",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "NONE",
                        "path": "jira.uiModifications"
                    },
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "condition": "includeEgressOverridesForge",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "inScopeEUD"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeEgressOverridesForge",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "overrides"
                                                },
                                                {
                                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                                    "kind": "LinkedField",
                                                    "name": "installationConfig",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "jira.forge.uiModificationsExtensions"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$0e39282743a555e2$var$node.hash = "01953a8343cba28dfd95163aae793a70";
var $0e39282743a555e2$export$2e2bcd8739ae039 = $0e39282743a555e2$var$node;

});

parcelRegister("kNIwY", function(module, exports) {

$parcel$export(module.exports, "AppsRenderer", () => $1baffba9b8ffecf0$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b9h8P = parcelRequire("b9h8P");

var $05b9c = parcelRequire("05b9c");

var $lCuYN = parcelRequire("lCuYN");

var $a4AFI = parcelRequire("a4AFI");
const $1baffba9b8ffecf0$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $lCuYN.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
            const { appId: appId, environmentId: envId } = (0, $05b9c.parseExtensionId)(forgeExtension.id);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9h8P.default), {
                data: {
                    attributes: {
                        appId: appId,
                        envId: envId
                    }
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4AFI.SingleAppRenderer), {
                    forgeExtension: forgeExtension,
                    uiModificationsConfig: uiModificationsConfig,
                    ForgeAppRenderer: ForgeAppRenderer
                })
            }, `${forgeExtension.id}-${triggerFieldInitializationKey}`);
        })
    });
};

});
parcelRegister("05b9c", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $5f3f6f7ec53c2d07$export$bae42cbaf7fa3e1b);

var $jbrzS = parcelRequire("jbrzS");
const $5f3f6f7ec53c2d07$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $jbrzS.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("a4AFI", function(module, exports) {

$parcel$export(module.exports, "SingleAppRenderer", () => $6721aa275247e9ca$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kZxLv = parcelRequire("kZxLv");

var $05b9c = parcelRequire("05b9c");

var $1x5z2 = parcelRequire("1x5z2");


var $k2BnG = parcelRequire("k2BnG");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $bBeSA = parcelRequire("bBeSA");

var $1Tlh3 = parcelRequire("1Tlh3");

var $21Nwj = parcelRequire("21Nwj");

var $d908a = parcelRequire("d908a");

var $33JDn = parcelRequire("33JDn");

var $1LUpJ = parcelRequire("1LUpJ");
const $6721aa275247e9ca$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const viewType = (0, $lyovk.useViewType)();
    const executionContext = (0, $k2BnG.useExecutionContext)();
    const extensionData = (0, $5uXOq.useMemo)(()=>(0, $1LUpJ.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $05b9c.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $21Nwj.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $1Tlh3.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $d908a.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $1x5z2.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $bBeSA.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $5bb8d9ab9691c174$export$d67d63332ce3ce38)) {
            setLoadingComplete();
            (0, $bBeSA.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $33JDn.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZxLv.default), {
        name: "single-frame-iframe",
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ForgeAppRenderer, {
            extension: forgeExtension,
            extensionData: extensionData,
            customBridgeMethods: customBridgeMethods,
            onIframeLoad: (0, $bBeSA.getAnalytics)(viewType).markIframeLoad,
            isIframeResizable: false,
            isIframeHidden: true,
            ...consentProps
        })
    }, moduleId);
};

});
const $5bb8d9ab9691c174$export$39d15f3568f5a72c = 'unknown';
const $5bb8d9ab9691c174$export$d67d63332ce3ce38 = 'required';
const $5bb8d9ab9691c174$export$45ca911896c5084f = 'consented';

parcelRegister("1Tlh3", function(module, exports) {

$parcel$export(module.exports, "useCustomBridgeMethods", () => $4c87313ece31dc3c$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");


var $auSkL = parcelRequire("auSkL");

var $dxuPk = parcelRequire("dxuPk");

var $kng3X = parcelRequire("kng3X");

var $3dc6V = parcelRequire("3dc6V");

var $8X5rF = parcelRequire("8X5rF");

var $iSzG6 = parcelRequire("iSzG6");
const $4c87313ece31dc3c$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $3dc6V.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $dxuPk.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $iSzG6.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $8X5rF.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $auSkL.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $kng3X.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $5uXOq.useCallback)(()=>{
        onBridgeCommunicationReceived?.();
        return {
            data: {
                onInitChangeId: (0, $d4f95b6a6c92b059$export$415cc1afa6445f90),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $5uXOq.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
const $d4f95b6a6c92b059$export$415cc1afa6445f90 = 'onInitChangeId';
const $d4f95b6a6c92b059$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("auSkL", function(module, exports) {

$parcel$export(module.exports, "useOnBridgeError", () => $9431f8196d51883b$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $k0qYG = parcelRequire("k0qYG");

var $d22NM = parcelRequire("d22NM");

var $fhvke = parcelRequire("fhvke");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $bBeSA = parcelRequire("bBeSA");

var $6kOsY = parcelRequire("6kOsY");
const $9431f8196d51883b$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(payload) && (0, $6kOsY.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $9431f8196d51883b$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const viewType = (0, $lyovk.useViewType)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((payload)=>{
        if (!$9431f8196d51883b$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $bBeSA.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`);
        (0, $fhvke.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error
            },
            event: createAnalyticsEvent({})
        });
    }, [
        setError,
        unregisterFields,
        createAnalyticsEvent,
        viewType,
        appId
    ]);
};

});
parcelRegister("6kOsY", function(module, exports) {

$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $365c0bc311968020$export$7845535459d8a620);
const $365c0bc311968020$export$6634aa68b37142fc = 'onInitError';
const $365c0bc311968020$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $365c0bc311968020$export$3018e0c759270938 = 'getApiError';
const $365c0bc311968020$export$7845535459d8a620 = [
    $365c0bc311968020$export$6634aa68b37142fc,
    $365c0bc311968020$export$7ab66e58aded6116,
    $365c0bc311968020$export$3018e0c759270938
];

});


parcelRegister("dxuPk", function(module, exports) {

$parcel$export(module.exports, "useOnChangeSubscription", () => $6ecfa886b028b2af$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $d22NM = parcelRequire("d22NM");

var $139nA = parcelRequire("139nA");

var $8WH2c = parcelRequire("8WH2c");

var $jKzPd = parcelRequire("jKzPd");

var $lyovk = parcelRequire("lyovk");

var $gVsIS = parcelRequire("gVsIS");

var $kED6g = parcelRequire("kED6g");
const $6ecfa886b028b2af$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $lyovk.useViewType)();
    const notifyAppRef = (0, $5uXOq.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $jKzPd.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $8WH2c.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    /**
	 * Single ref for all data that must be up-to-date but not trigger notification.
	 */ const dataRef = (0, $5uXOq.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $5uXOq.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $gVsIS.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $kED6g.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $5uXOq.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("8WH2c", function(module, exports) {

$parcel$export(module.exports, "useCurrentFormState", () => $e16e8beb910eb51a$export$655680d54d70050d);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1Q1Gm = parcelRequire("1Q1Gm");
const $e16e8beb910eb51a$var$stableEmpty = {};
const $e16e8beb910eb51a$var$stableEmptyScreenTabsArrray = [];
const $e16e8beb910eb51a$var$selectCurrentFormState = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $e16e8beb910eb51a$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $e16e8beb910eb51a$var$stableEmpty,
        currentScreenTabsState: $e16e8beb910eb51a$var$stableEmptyScreenTabsArrray
    };
});
const $e16e8beb910eb51a$export$655680d54d70050d = (0, $3sQ5x.createStateHook)((0, $1Q1Gm.store), {
    selector: $e16e8beb910eb51a$var$selectCurrentFormState
});

});

parcelRegister("jKzPd", function(module, exports) {

$parcel$export(module.exports, "useLastProcessedChange", () => $c48cc48559a9059a$export$e5124fbd2a3221d);

var $3sQ5x = parcelRequire("3sQ5x");

var $1Q1Gm = parcelRequire("1Q1Gm");
const $c48cc48559a9059a$export$e5124fbd2a3221d = (0, $3sQ5x.createStateHook)((0, $1Q1Gm.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("gVsIS", function(module, exports) {

$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $7999f3509bd587ed$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $7999f3509bd587ed$export$51fbc854b278b1ff);

var $bBeSA = parcelRequire("bBeSA");
const $7999f3509bd587ed$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    const fieldRequiredScopes = (0, $bBeSA.getSupportedFieldConfiguration)(viewType, fieldType)?.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $7999f3509bd587ed$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!value?.fieldType) return false;
        const { fieldType: fieldType } = value;
        return $7999f3509bd587ed$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $7999f3509bd587ed$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field?.fieldType;
        if (!fieldType) return false;
        return $7999f3509bd587ed$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("kED6g", function(module, exports) {

$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $66d9180dbf05dc97$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $66d9180dbf05dc97$export$6a622a0cc96dcad7);

var $139nA = parcelRequire("139nA");

var $1YCiq = parcelRequire("1YCiq");
const $66d9180dbf05dc97$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $66d9180dbf05dc97$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $66d9180dbf05dc97$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($66d9180dbf05dc97$var$includeCoarseScopes((0, $1YCiq.baseRequiredReadScopes), moduleScopes) || $66d9180dbf05dc97$var$includeGranularScopes((0, $1YCiq.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $66d9180dbf05dc97$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($66d9180dbf05dc97$var$includeCoarseScopes((0, $1YCiq.baseRequiredWriteScopes), moduleScopes) || $66d9180dbf05dc97$var$includeGranularScopes((0, $1YCiq.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("1YCiq", function(module, exports) {

$parcel$export(module.exports, "baseRequiredReadScopes", () => $6d830e56667a92c0$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $6d830e56667a92c0$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $6d830e56667a92c0$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $6d830e56667a92c0$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("kng3X", function(module, exports) {

$parcel$export(module.exports, "useOnErrorSubscription", () => $cb5f68655048dfb5$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $d22NM = parcelRequire("d22NM");

var $139nA = parcelRequire("139nA");

var $cNvK1 = parcelRequire("cNvK1");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");
const $cb5f68655048dfb5$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $lyovk.useViewType)();
    const notifyAppRef = (0, $5uXOq.useRef)(null);
    const { appErrors: appErrors } = (0, $cNvK1.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    (0, $5uXOq.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $5uXOq.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("cNvK1", function(module, exports) {

$parcel$export(module.exports, "useAppErrors", () => $234e9c053af8d620$export$535312244836989b);

var $3sQ5x = parcelRequire("3sQ5x");

var $1Q1Gm = parcelRequire("1Q1Gm");
const $234e9c053af8d620$export$535312244836989b = (0, $3sQ5x.createStateHook)((0, $1Q1Gm.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("3dc6V", function(module, exports) {

$parcel$export(module.exports, "useOnInit", () => $2d3d1356aa1f6635$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $d22NM = parcelRequire("d22NM");

var $139nA = parcelRequire("139nA");

var $lxZxm = parcelRequire("lxZxm");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $bBeSA = parcelRequire("bBeSA");

var $gVsIS = parcelRequire("gVsIS");

var $kED6g = parcelRequire("kED6g");
const $2d3d1356aa1f6635$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $2d3d1356aa1f6635$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $5uXOq.useRef)(null);
    const viewType = (0, $lyovk.useViewType)();
    const publicUIMDataForApp = (0, $lxZxm.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $5uXOq.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $gVsIS.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $kED6g.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $2d3d1356aa1f6635$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $bBeSA.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("lxZxm", function(module, exports) {

$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $368d303ebfb5b6e5$export$484a467ba25fea19);

var $3sQ5x = parcelRequire("3sQ5x");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $2lYyb = parcelRequire("2lYyb");
const $368d303ebfb5b6e5$export$484a467ba25fea19 = (0, $3sQ5x.createStateHook)((0, $1Q1Gm.store), {
    selector: (0, $2lYyb.selectReadyPublicDataForOnInit)
});

});


parcelRegister("8X5rF", function(module, exports) {

$parcel$export(module.exports, "useRegisterFields", () => $7ae0ef0a5c8b4c11$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $bBeSA = parcelRequire("bBeSA");
const $7ae0ef0a5c8b4c11$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const viewType = (0, $lyovk.useViewType)();
    return (0, $5uXOq.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $bBeSA.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("iSzG6", function(module, exports) {

$parcel$export(module.exports, "useSubmit", () => $e383a198aecb9ab3$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8Uumt = parcelRequire("8Uumt");

var $d22NM = parcelRequire("d22NM");

var $fhvke = parcelRequire("fhvke");
var $139nA = parcelRequire("139nA");
var $32nzP = parcelRequire("32nzP");

var $k2BnG = parcelRequire("k2BnG");

var $eTjvl = parcelRequire("eTjvl");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $8sH29 = parcelRequire("8sH29");

var $385kh = parcelRequire("385kh");

var $bBeSA = parcelRequire("bBeSA");

var $kED6g = parcelRequire("kED6g");

var $kyc6m = parcelRequire("kyc6m");

var $bttMb = parcelRequire("bttMb");
const $e383a198aecb9ab3$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const viewType = (0, $lyovk.useViewType)();
    const getAsyncLookupData = (0, $eTjvl.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $bttMb.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $385kh.useTenantContext)();
    const executionContext = (0, $k2BnG.useExecutionContext)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $kyc6m.useFieldsChangesValidation)();
    const intl = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        try {
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $kED6g.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $bBeSA.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            (0, $32nzP.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${viewType}jiraUiModificationsUseSubmit`
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $bBeSA.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $8sH29.UiModificationsValidationError)) {
                (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $fhvke.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err?.cause
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields
    ]);
};

});
parcelRegister("32nzP", function(module, exports) {

$parcel$export(module.exports, "fireTrackEvent", () => $d015bde34dae714e$export$574d2f19a52d67ca);

var $4NUyc = parcelRequire("4NUyc");


const $d015bde34dae714e$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $4NUyc.default)((0, $9b09a7c44fb10ce4$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $a4b88d0b3c6e1903$export$947dac6c72b26f81)
    })(createAnalyticsEvent);
};

});
const $a4b88d0b3c6e1903$export$f636b5b56f1d624a = 'Screen';
const $a4b88d0b3c6e1903$export$9d2de6eebf7462b5 = 'Drawer';
const $a4b88d0b3c6e1903$export$1171103ea9083ffa = 'Modal';
const $a4b88d0b3c6e1903$export$cae2783c9279926 = 'InlineDialog';
const $a4b88d0b3c6e1903$export$d1123261ca8831d2 = 'Dropdown';
const $a4b88d0b3c6e1903$export$a1562d08625f5d7e = 'UI';
const $a4b88d0b3c6e1903$export$947dac6c72b26f81 = 'TRACK';
const $a4b88d0b3c6e1903$export$f1d537d508d2945a = 'SCREEN';
const $a4b88d0b3c6e1903$export$12346a674644c156 = 'OPERATIONAL';
const $a4b88d0b3c6e1903$export$2ceccf177fae277c = 'analyticsBridge';

const $9b09a7c44fb10ce4$export$8280e5c6104c5b40 = 'ui-modifications';


parcelRegister("eTjvl", function(module, exports) {

$parcel$export(module.exports, "useLookupFieldData", () => $374a7e2f7b5d0c62$export$d43e9e394c54e784);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $gKZoD = parcelRequire("gKZoD");

var $8Uumt = parcelRequire("8Uumt");

var $d22NM = parcelRequire("d22NM");


var $h5hSS = parcelRequire("h5hSS");

var $b8IMK = parcelRequire("b8IMK");

var $1Ljm8 = parcelRequire("1Ljm8");

var $lyovk = parcelRequire("lyovk");

var $bBeSA = parcelRequire("bBeSA");
const $374a7e2f7b5d0c62$export$d43e9e394c54e784 = ()=>{
    (0, $gKZoD.di)((0, $8Uumt.useRelayEnvironment), (0, $1Ljm8.useFormMetadata), (0, $b8IMK.fetchUsers), (0, $lyovk.useViewType));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const formMetadata = (0, $1Ljm8.useFormMetadata)();
    const formMetadataRef = (0, $5uXOq.useRef)(formMetadata);
    const viewType = (0, $lyovk.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    return (0, $5uXOq.useCallback)(async (fieldsChanges)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $bBeSA.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration?.lookupSource;
            const isUserLookupField = lookupSource === (0, $d21a92d5c5477ce8$export$3a106242c8f57ac2);
            if (isUserLookupField && fieldValue && (0, $h5hSS.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            /** Add extra checks to add other lookup type e.g. issues lookup */ return acc;
        }, {});
        let users = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(asyncFieldsValues.accountIds);
            users = await (0, $b8IMK.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        lookupData[0, $d21a92d5c5477ce8$export$3a106242c8f57ac2] = users;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment
    ]);
};

});
const $d21a92d5c5477ce8$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $d21a92d5c5477ce8$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $d21a92d5c5477ce8$export$f5d5f6bb902f1027 = '-1';
const $d21a92d5c5477ce8$export$106087dcfd4fb129 = 100;

parcelRegister("h5hSS", function(module, exports) {

$parcel$export(module.exports, "isNotAutomaticId", () => $a0ec8a88d0f49a98$export$ab4c3a3c49d7add);

const $a0ec8a88d0f49a98$export$ab4c3a3c49d7add = (value)=>value !== (0, $d21a92d5c5477ce8$export$f5d5f6bb902f1027);

});

parcelRegister("b8IMK", function(module, exports) {

$parcel$export(module.exports, "fetchUsers", () => $37a4fea484ca53d5$export$2bb8333a9210be15);

var $htx4F = parcelRequire("htx4F");

var $8Uumt = parcelRequire("8Uumt");

var $139nA = parcelRequire("139nA");

var $70nxJ = parcelRequire("70nxJ");
const $37a4fea484ca53d5$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $8Uumt.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $htx4F.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response?.users) throw new (0, $70nxJ.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("htx4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $7db8561552c6201c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6109c01c0559b2d0812b75c892a215b7>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $7db8561552c6201c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7db8561552c6201c$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $7db8561552c6201c$export$2e2bcd8739ae039 = $7db8561552c6201c$var$node;

});

parcelRegister("70nxJ", function(module, exports) {

$parcel$export(module.exports, "ErrorWithStatusCode", () => $81e197396737128b$export$13144d723cf04c);
class $81e197396737128b$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("1Ljm8", function(module, exports) {

$parcel$export(module.exports, "useFormMetadata", () => $0de034667e34a92b$export$863414fa128cb7ef);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1Q1Gm = parcelRequire("1Q1Gm");
const $0de034667e34a92b$var$selectFormMetadata = (0, $6dDSs.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $0de034667e34a92b$export$863414fa128cb7ef = (0, $3sQ5x.createStateHook)((0, $1Q1Gm.store), {
    selector: $0de034667e34a92b$var$selectFormMetadata
});

});


parcelRegister("kyc6m", function(module, exports) {

$parcel$export(module.exports, "useFieldsChangesValidation", () => $d5133b4fc0337d57$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $d22NM = parcelRequire("d22NM");

var $8WH2c = parcelRequire("8WH2c");

var $1Ljm8 = parcelRequire("1Ljm8");

var $lyovk = parcelRequire("lyovk");

var $kfSzz = parcelRequire("kfSzz");

var $fOZAL = parcelRequire("fOZAL");
const $d5133b4fc0337d57$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $d5133b4fc0337d57$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $d5133b4fc0337d57$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const formMetadata = (0, $1Ljm8.useFormMetadata)();
    const formMetadataRef = (0, $5uXOq.useRef)(formMetadata);
    const viewType = (0, $lyovk.useViewType)();
    const { currentFormState: currentFormState } = (0, $8WH2c.useCurrentFormState)();
    const currentFormStateRef = (0, $5uXOq.useRef)(currentFormState);
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $5uXOq.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $fOZAL.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $d5133b4fc0337d57$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $kfSzz.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $d5133b4fc0337d57$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("fOZAL", function(module, exports) {

$parcel$export(module.exports, "validateFieldChanges", () => $29facfc1c92f2c9d$export$a2b7ddd7c3d0703a);

var $bBeSA = parcelRequire("bBeSA");

var $g978r = parcelRequire("g978r");

var $e6dUv = parcelRequire("e6dUv");
const $29facfc1c92f2c9d$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $bBeSA.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $g978r.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $e6dUv.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $e6dUv.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $g978r.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $e6dUv.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $g978r.VALID_RESULT;
};

});
parcelRegister("g978r", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $8d3d512d095f5d78$export$ee79e3ab53b8db79);
const $8d3d512d095f5d78$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("e6dUv", function(module, exports) {

$parcel$export(module.exports, "prepareValidationResult", () => $b9f307a3a4bdcbd9$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $b9f307a3a4bdcbd9$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $b9f307a3a4bdcbd9$export$fd744b06c9068a9e);


var $hYoPR = parcelRequire("hYoPR");

var $g978r = parcelRequire("g978r");
const $b9f307a3a4bdcbd9$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $6a9602f8c1eeb038$export$d1996cb46a690190),
            method: (0, $hYoPR.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $g978r.VALID_RESULT;
};
const $b9f307a3a4bdcbd9$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $6a9602f8c1eeb038$export$d1996cb46a690190),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $g978r.VALID_RESULT;
};
const $b9f307a3a4bdcbd9$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $b9f307a3a4bdcbd9$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $b9f307a3a4bdcbd9$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $b9f307a3a4bdcbd9$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $b9f307a3a4bdcbd9$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});
const $6a9602f8c1eeb038$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $6a9602f8c1eeb038$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $6a9602f8c1eeb038$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $6a9602f8c1eeb038$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $6a9602f8c1eeb038$export$e4ac32edd5da2ee7 = 'FIELD';
const $6a9602f8c1eeb038$export$877da1000325f8b5 = 'SCREENTABS';




parcelRegister("bttMb", function(module, exports) {

$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $cb6c54f7fcbdfe6a$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $8WH2c = parcelRequire("8WH2c");

var $lyovk = parcelRequire("lyovk");

var $gVsIS = parcelRequire("gVsIS");
const $cb6c54f7fcbdfe6a$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $8WH2c.useCurrentFormState)();
    const currentFormStateRef = (0, $5uXOq.useRef)(currentFormState);
    const viewType = (0, $lyovk.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ currentFormStateRef.current = currentFormState;
    return (0, $5uXOq.useCallback)((fieldChanges)=>(0, $gVsIS.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("21Nwj", function(module, exports) {

$parcel$export(module.exports, "useIframeTimeout", () => $db0b60e1d1f87150$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $d22NM = parcelRequire("d22NM");

var $139nA = parcelRequire("139nA");

var $lyovk = parcelRequire("lyovk");
const $db0b60e1d1f87150$export$45f7ef64ce535ffd = 12000;
const $db0b60e1d1f87150$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $5uXOq.useRef)(undefined);
    const callbackRef = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const viewType = (0, $lyovk.useViewType)();
    const onTimeout = (0, $5uXOq.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$db0b60e1d1f87150$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $db0b60e1d1f87150$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("d908a", function(module, exports) {

$parcel$export(module.exports, "useScopeChecks", () => $e5d3ea8f3c281704$export$5b312a37a22a70a8);

var $ic1tn = parcelRequire("ic1tn");
const $e5d3ea8f3c281704$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $ic1tn.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $ic1tn.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("ic1tn", function(module, exports) {

$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $634714c275da3bd1$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $634714c275da3bd1$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $634714c275da3bd1$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $634714c275da3bd1$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("33JDn", function(module, exports) {

$parcel$export(module.exports, "useThreeLOPromptProps", () => $ae53955acd6877a8$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $d22NM = parcelRequire("d22NM");

var $05b9c = parcelRequire("05b9c");

var $139nA = parcelRequire("139nA");

var $juYnC = parcelRequire("juYnC");

var $1x5z2 = parcelRequire("1x5z2");


var $lyovk = parcelRequire("lyovk");

var $bBeSA = parcelRequire("bBeSA");
const $ae53955acd6877a8$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $juYnC.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $05b9c.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $lyovk.useViewType)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const currentUIModificationsConsentStatus = (0, $1x5z2.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $5uXOq.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $5bb8d9ab9691c174$export$45ca911896c5084f)
        });
        (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $5uXOq.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $5bb8d9ab9691c174$export$39d15f3568f5a72c)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $5bb8d9ab9691c174$export$d67d63332ce3ce38)
            });
            if (!hasBeenTracked) {
                (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $5uXOq.useMemo)(()=>{
        return formatMessage((0, $bBeSA.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $5uXOq.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("1LUpJ", function(module, exports) {

$parcel$export(module.exports, "buildExtensionData", () => $bb88a7b979a616ad$export$141a9933f8885d99);

const $bb88a7b979a616ad$export$141a9933f8885d99 = (executionContext)=>{
    return {
        type: (0, $d4f95b6a6c92b059$export$811b7f067a43b422),
        ...executionContext
    };
};

});



parcelRegister("iSXsw", function(module, exports) {

$parcel$export(module.exports, "useAppsToRender", () => $8832948784d6e16a$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $d22NM = parcelRequire("d22NM");

var $139nA = parcelRequire("139nA");

var $juYnC = parcelRequire("juYnC");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");


var $5yK4r = parcelRequire("5yK4r");
const $8832948784d6e16a$export$bef357953bcc2428 = (payload)=>{
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $juYnC.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const viewType = (0, $lyovk.useViewType)();
    const configuredApps = (0, $5uXOq.useMemo)(()=>(0, $5yK4r.getConfiguredApps)(data.jira?.forge?.uiModificationsExtensions, data.jira?.uiModifications), [
        data.jira?.forge?.uiModificationsExtensions,
        data.jira?.uiModifications
    ]);
    const appsToRender = (0, $5uXOq.useMemo)(()=>{
        return configuredApps.slice(0, (0, $43aa9d6b0eafb903$export$575c2f3c7fe81caa));
    }, [
        configuredApps
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (data.jira?.uiModifications !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        data.jira?.uiModifications
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) (0, $139nA.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.configuredAppsPerContext',
            attributes: {
                forgeModulesCount: data.jira?.forge?.uiModificationsExtensions.length,
                uimConfiguredAppCount: data.jira?.uiModifications.length,
                configuredAndInstalledApps: configuredAppsCount,
                areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                viewType: viewType
            }
        });
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        data.jira?.forge?.uiModificationsExtensions.length,
        data.jira?.uiModifications.length
    ]);
    return appsToRender;
};

});
const $43aa9d6b0eafb903$export$575c2f3c7fe81caa = 5;

parcelRegister("5yK4r", function(module, exports) {

$parcel$export(module.exports, "getConfiguredApps", () => $897a703cb8fbba30$export$6ead423ef319ea49);

var $jzFwh = parcelRequire("jzFwh");
const $897a703cb8fbba30$var$STABLE_EMPTY_ARRAY = [];
const $897a703cb8fbba30$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $897a703cb8fbba30$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $jzFwh.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("jzFwh", function(module, exports) {

$parcel$export(module.exports, "normalizeExtensions", () => $0720ed6658830c19$export$7e2e604b6166a087);

var $05b9c = parcelRequire("05b9c");
const $0720ed6658830c19$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $05b9c.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("7XJD9", function(module, exports) {

$parcel$export(module.exports, "useContextCleanup", () => $7c56372f47ff98d1$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $5uXOq = parcelRequire("5uXOq");

var $juYnC = parcelRequire("juYnC");

var $lyovk = parcelRequire("lyovk");

var $1Q1Gm = parcelRequire("1Q1Gm");

var $bBeSA = parcelRequire("bBeSA");
const $7c56372f47ff98d1$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $1Q1Gm.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $juYnC.useAdjustmentsContextActions)();
    const viewType = (0, $lyovk.useViewType)();
    (0, $5uXOq.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $bBeSA.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("fKN80", function(module, exports) {

$parcel$export(module.exports, "useEnrichedExecutionContext", () => $526e3329fdb6eaaf$export$649da33b72723913);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $lyovk = parcelRequire("lyovk");
const $526e3329fdb6eaaf$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    (0, $gKZoD.di)((0, $lyovk.useViewType));
    const viewType = (0, $lyovk.useViewType)();
    const enrichedExecutionContext = (0, $5uXOq.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});





//# sourceMappingURL=async-ui-modifications-root-entrypoint.925af165.js.map
